import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class SkeletonLoadersListModule {
}
SkeletonLoadersListModule.ɵfac = function SkeletonLoadersListModule_Factory(t) { return new (t || SkeletonLoadersListModule)(); };
SkeletonLoadersListModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SkeletonLoadersListModule });
SkeletonLoadersListModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
